import { DataLoadURL } from '../../shared/model/api.model';

/**
 * Defines the supported API routes for audit.
 */
export const AUDIT_ENDPOINTS = {
  /** Simple post call that requires a search body payload. */
  searchAudit: {
    hostName: 'admin-portal-api',
    method: 'POST',
    url: 'lender/{lendercode}/audit/search'
  } as DataLoadURL,
  /** Simple get call that takes an id in the URI. */
  getAuditDetails: {
    hostName: 'admin-portal-api',
    method: 'GET',
    url: 'lender/{lendercode}/audit/{id}'
  } as DataLoadURL,
  /** Gets the latest 10 results for dashboard */
  getAuditLatest: {
    hostName: 'admin-portal-api',
    method: 'GET',
    url: 'lender/{lendercode}/audit'
  } as DataLoadURL,
  /** pings the API for a login event */
  auditLoginEvent: {
    hostName: 'admin-portal-api',
    method: 'GET',
    url: 'lender/{lendercode}/audit/login'
  } as DataLoadURL
};
